export default __webpack_public_path__ + "static/media/volic1.8af75184.jpg";